import { Box, Typography } from '@mui/material'
import React from 'react'
import styled from "styled-components";

const StyledLink = styled.a`
       border-radius:50%;
       width:10%;
       height:30px;
       line-height:30px;
       display: flex;
       align-items: center;
       justify-content: flex-start;
       text-decoration: none;
       margin: 16px 8px;
   
  `;
const ContactSocial = ({ link, text, children }) => {


  return (
    <>
      <StyledLink href={link} >
        <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {children}
          <Typography variant='body1' color={'primary.text'} mb={1} mt={2} sx={{ textTransform: 'capitalize' }}>{text}</Typography>
        </Box>
      </StyledLink>
    </>
  )
}

export default ContactSocial